(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller-carousel"] && !Shopify.designMode) return;
  try {
    

(function () {
  document.querySelectorAll('.bestseller-carousel').forEach(function (section) {
    var wrap     = section.querySelector('[data-wrap]');
    var track    = section.querySelector('[data-track]');
    var btnPrev  = section.querySelector('[data-prev]');
    var btnNext  = section.querySelector('[data-next]');
    var bar      = section.querySelector('[data-progress-bar]');
    var controls = section.querySelector('.bestseller-carousel__controls');

    if (!track || !wrap) return;

    var VISIBLE = 4;
    var index = 0;

    function isMobile() {
      return window.innerWidth < 750;
    }

    function cards() {
      return Array.from(track.querySelectorAll('.product-card'));
    }

    function gapPx() {
      var g = parseFloat(getComputedStyle(track).gap);
      return isNaN(g) ? 20 : g;
    }

    function maxIndex() {
      return Math.max(0, cards().length - VISIBLE);
    }

    function setCardWidths() {
      var wrapW = wrap.offsetWidth;
      var g = gapPx();
      var w = (wrapW - (VISIBLE - 1) * g) / VISIBLE;
      cards().forEach(function (c) {
        c.style.flex = '0 0 ' + w + 'px';
      });
    }

    function applyTransform() {
      var g = gapPx();
      var first = cards()[0];
      if (!first) return;
      var w = first.offsetWidth;
      track.style.transform = 'translateX(' + (-index * (w + g)) + 'px)';
    }

    function updateUI() {
      var max   = maxIndex();
      var total = cards().length;

      if (btnPrev) btnPrev.disabled = index <= 0;
      if (btnNext) btnNext.disabled = index >= max;

      if (bar) {
        var pct = total > VISIBLE ? ((index + VISIBLE) / total) * 100 : 100;
        bar.style.width = pct + '%';
      }
    }

    function go(dir) {
      index = Math.min(maxIndex(), Math.max(0, index + dir));
      applyTransform();
      updateUI();
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { go(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { go(1); });

    function init() {
      if (isMobile()) {
        cards().forEach(function (c) { c.style.flex = ''; });
        track.style.transform = '';
        return;
      }
      index = Math.min(index, maxIndex());
      setCardWidths();
      applyTransform();
      updateUI();
      if (controls) {
        controls.style.visibility = maxIndex() > 0 ? '' : 'hidden';
      }
    }

    init();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 120);
    });

    // Scroll-triggered reveal — or immediate in theme editor
    if (window.Shopify && window.Shopify.designMode) {
      section.classList.add('is-revealed');
    } else if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 }).observe(section);
    } else {
      section.classList.add('is-revealed');
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.related-products[data-section-id]').forEach(function (el) {
      var productId = el.dataset.productId;
      var sectionId = el.dataset.sectionId;
      var limit = el.dataset.limit || '4';

      if (!productId || !sectionId) return;

      var url =
        '/recommendations/products?product_id=' +
        productId +
        '&section_id=' +
        sectionId +
        '&limit=' +
        limit +
        '&intent=related';

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('#related-products-' + sectionId);
          if (incoming && incoming.querySelector('.product-card')) {
            el.innerHTML = incoming.innerHTML;
          }
        })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
